import React from 'react';
import Base from './Base';

export default class ContractDocumentsModal extends Base {
    constructor(props) {
        super(props);
        this.state = {
            documents: [],
            loading: false,
            showUpload: false,
            newDoc: {
                documentType: '',
                description: '',
                fileBase64: '',
                fileName: ''
            },
            selectedDoc: null, 
            commentText: ''
        };
    }

    componentDidMount() {
        if (this.props.contractId) {
            this.loadDocuments();
        }
    }

    loadDocuments() {
        if (!this.props.contractId) return;
        this.setState({ loading: true });
        this.httpPost('api/v1/contractdocument/list', { contractId: this.props.contractId })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ documents: data.records, loading: false });
                } else {
                    this.showErorrMessage(data.message || 'خطا');
                    this.setState({ loading: false });
                }
            });
    }

    handleUpload() {
        const fd = this.state.newDoc;
        if (!fd.fileBase64) {
            this.showErorrMessage('لطفاً فایلی انتخاب کنید');
            return;
        }
        this.setState({ lockScreen: 1 });
        this.httpPost('api/v1/contractdocument/save', {
            id: 0,
            contractId: this.props.contractId,
            documentType: fd.documentType,
            description: fd.description,
            fileBase64: fd.fileBase64,
            fileName: fd.fileName
        }).then(data => {
            this.setState({ lockScreen: 0 });
            if (data.status === 1) {
                this.showSuccessMessage('مدرک آپلود شد');
                this.setState({ showUpload: false, newDoc: { documentType: '', description: '', fileBase64: '', fileName: '' } });
                this.loadDocuments();
            } else {
                this.showErorrMessage(data.message);
            }
        });
    }

    handleFileSelect(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(',')[1];
            this.setState({ newDoc: { ...this.state.newDoc, fileBase64: base64, fileName: file.name } });
        };
        reader.readAsDataURL(file);
    }

    downloadDocument(docId, fileName) {
        window.open(`/api/v1/contractdocument/download/${docId}`, '_blank');
    }

    deleteDocument(id) {
        if (!window.confirm('مطمئن هستید؟')) return;
        this.httpPost('api/v1/contractdocument/remove', { id })
            .then(data => {
                if (data.status === 1) {
                    this.showSuccessMessage('حذف شد');
                    this.loadDocuments();
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    async selectDocument(docId) {
        this.setState({ loading: true });
        this.httpPost('api/v1/contractdocument/get', { id: docId })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ selectedDoc: data.record, loading: false, commentText: '' });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    addComment() {
        if (!this.state.commentText.trim()) return;
        this.httpPost('api/v1/contractdocument/addcomment', {
            documentId: this.state.selectedDoc.id,
            content: this.state.commentText
        }).then(data => {
            if (data.status === 1) {

                const updatedDoc = { ...this.state.selectedDoc };
                updatedDoc.notes.push(data.note);
                this.setState({ selectedDoc: updatedDoc, commentText: '' });
                this.showSuccessMessage('کامنت ثبت شد');
            } else {
                this.showErorrMessage(data.message);
            }
        });
    }

    render() {
        const { show, onClose } = this.props;
        if (!show) return null;

        const { documents, loading, showUpload, newDoc, selectedDoc, commentText } = this.state;

        return (
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">مدارک قرارداد</h5>
                            <button type="button" className="close" onClick={onClose}>&times;</button>
                        </div>
                        <div className="modal-body">
                            {loading && this.renderLoading()}

      
                            <div className="mb-3">
                                <button className="btn btn-primary" onClick={() => this.setState({ showUpload: !showUpload })}>
                                    {showUpload ? 'انصراف' : 'آپلود مدرک جدید'}
                                </button>
                                {showUpload && (
                                    <div className="card card-bordered mt-2 p-3">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label>نوع مدرک</label>
                                                <input className="form-control" value={newDoc.documentType} onChange={e => this.setState({ newDoc: { ...newDoc, documentType: e.target.value } })} />
                                            </div>
                                            <div className="col-md-6">
                                                <label>توضیح</label>
                                                <input className="form-control" value={newDoc.description} onChange={e => this.setState({ newDoc: { ...newDoc, description: e.target.value } })} />
                                            </div>
                                            <div className="col-md-6">
                                                <label>فایل</label>
                                                <input type="file" className="form-control" onChange={e => this.handleFileSelect(e)} />
                                                {newDoc.fileName && <small>{newDoc.fileName}</small>}
                                            </div>
                                            <div className="col-12 mt-2">
                                                <button className="btn btn-success" onClick={() => this.handleUpload()}>آپلود</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>نوع</th>
                                        <th>نام فایل</th>
                                        <th>توضیح</th>
                                        <th>تاریخ</th>
                                        <th>کامنت‌ها</th>
                                        <th>عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documents.map(doc => (
                                        <tr key={doc.id}>
                                            <td>{doc.documentType}</td>
                                            <td>{doc.fileName}</td>
                                            <td>{doc.description}</td>
                                            <td>{doc.uploadDatePersian}</td>
                                            <td>{doc.notesCount}</td>
                                            <td>
                                                <button className="btn btn-sm btn-info" onClick={() => this.selectDocument(doc.id)}>
                                                    <em className="icon ni ni-comments"></em>
                                                </button>
                                                <button className="btn btn-sm btn-primary ml-1" onClick={() => this.downloadDocument(doc.id, doc.fileName)}>
                                                    <em className="icon ni ni-download"></em>
                                                </button>
                                                <button className="btn btn-sm btn-danger ml-1" onClick={() => this.deleteDocument(doc.id)}>
                                                    <em className="icon ni ni-trash"></em>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {selectedDoc && (
                                <div className="card card-bordered mt-3 p-3">
                                    <h6>جزئیات: {selectedDoc.fileName}</h6>
                                    <p>نوع: {selectedDoc.documentType} | توضیح: {selectedDoc.description}</p>
                                    <hr />
                                    <h6>تاریخچه / کامنت‌ها</h6>
                                    <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                                        {selectedDoc.notes.map(note => (
                                            <div key={note.id} className="mb-2">
                                                <strong>{note.createdByName}</strong> - {note.createdDatePersian}
                                                <p>{note.content}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="input-group mt-2">
                                        <input className="form-control" value={commentText} onChange={e => this.setState({ commentText: e.target.value })} placeholder="کامنت جدید..." />
                                        <button className="btn btn-primary" onClick={() => this.addComment()}>ارسال</button>
                                    </div>
                                    <button className="btn btn-secondary mt-2" onClick={() => this.setState({ selectedDoc: null })}>بستن</button>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>بستن</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}